document.addEventListener('DOMContentLoaded', function () {
  var articleBody = document.querySelector('.article-template__content');
  var layout = document.querySelector('.article-template__body-with-toc');
  var toc = document.getElementById('ArticleToc');
  var tocList = document.getElementById('ArticleTocList');
  var mobileToc = document.getElementById('ArticleTocMobile');
  var mobileTocList = document.getElementById('ArticleTocMobileList');
  var tocCount = document.getElementById('ArticleTocCount');

  if (!articleBody || !toc || !tocList) return;

  var headings = Array.prototype.slice.call(articleBody.querySelectorAll('h2')).filter(function (heading) {
    var text = heading.textContent.trim();

    if (!text) return false;
    if (/^h1[:：]/i.test(text)) return false;

    return true;
  });

  if (headings.length < 3) {
    toc.hidden = true;
    if (mobileToc) mobileToc.hidden = true;
    if (layout) layout.classList.add('article-template__body-with-toc--no-toc');
    return;
  }

  var usedIds = {};

  function normalizeHeadingText(text) {
    return text.replace(/^\d+[\.)]\s*/, '').replace(/\s+/g, ' ').trim();
  }

  function createSlug(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/^\d+[\.)]\s*/, '')
      .replace(/\s+/g, '-')
      .replace(/[^\w\u4e00-\u9fa5-]/g, '')
      .replace(/-+/g, '-');
  }

  function buildItem(text, id, fullText) {
    var li = document.createElement('li');
    var link = document.createElement('a');

    li.className = 'article-toc__item';
    link.href = '#' + id;
    link.textContent = text;
    link.title = fullText;

    li.appendChild(link);

    return li;
  }

  headings.forEach(function (heading, index) {
    var originalText = heading.textContent.trim();
    var fullTocText = normalizeHeadingText(originalText);
    var baseId = heading.id || createSlug(originalText) || 'section-' + (index + 1);
    var uniqueId = baseId;

    if (usedIds[baseId]) {
      usedIds[baseId] += 1;
      uniqueId = baseId + '-' + usedIds[baseId];
    } else {
      usedIds[baseId] = 1;
    }

    heading.id = uniqueId;
    tocList.appendChild(buildItem(fullTocText, uniqueId, fullTocText));

    if (mobileTocList) {
      mobileTocList.appendChild(buildItem(fullTocText, uniqueId, fullTocText));
    }
  });

  if (tocCount && mobileToc) {
    var label = headings.length === 1 ? mobileToc.dataset.sectionSingular : mobileToc.dataset.sectionPlural;
    tocCount.textContent = label.replace(/\d+/, headings.length);
  }
});
